<template>
    <div style="background-color: white;box-sizing:unset;min-width:1600px">
        <headers></headers>
        <!-- 中间内容区域开始 -->
         <!-- 中文版 -->
        <div v-if="langluageType != 'en'" class="window_con">
            <div class="window_banner">
                <img src="../assets/propaganda/articlepro.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/project_logo.svg" class="banner_text_img">
                    <h1>面向专业展装企业</h1>
                    <p>展装项目管理全流程一体化实时在线云管理系统</p>
                    <ul class="banner_ul">
                        <li data-type="Project展装云" data-href="/web/user/login" id="ljsy"><a href="javascript:;">立&nbsp;即&nbsp;试&nbsp;用</a></li>
                    </ul>
                </div>
            </div>
            <div class="article">
                <h1>展装云的解决方案</h1>
                <div class="tit_con">
                    <p>解决传统模式中，企业营销流程乱、销售痕迹监管难、项目客户粘性低、项目财务管控难、供应体系管理乱、现场执行品质劣等问题</p>
                </div>
                <div class="article_con clearfix">
                    <div class="article_con_module">
                        <h2>提高业务敏捷性</h2>
                        <ul>
                            <li><i class="square"></i>行业特定的功能和卓越实践</li>
                            <li><i class="square"></i>基于上百家展装企业管理流程</li>
                            <li><i class="square"></i>实时嵌入式BI统计分析</li>
                            <li><i class="square"></i>覆盖展装企业全业务自动化流程</li>
                        </ul>
                    </div>
                    <div class="article_con_module">
                        <h2>获得稳定性和控制力</h2>
                        <ul>
                            <li><i class="square"></i>腾讯云部署确保数据安全</li>
                            <li><i class="square"></i>集成的商业智能快速把握新机遇</li>
                            <li><i class="square"></i>项目创建、项目发配、简化流程</li>
                            <li><i class="square"></i>注册即用，部署速度快</li>
                        </ul>
                    </div>
                    <div class="article_con_module">
                        <h2>持续降本可持续性</h2>
                        <ul>
                            <li><i class="square"></i>销售跟踪、客户管理同步灵活</li>
                            <li><i class="square"></i>内部沟通、供应管理敏捷性高</li>
                            <li><i class="square"></i>现场监督、财务监管管理高效</li>
                            <li><i class="square"></i>支持实时分析，帮助提高利润和效率</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 英文版 -->
        <div v-else class="window_con">
            <div class="window_banner">
                <img src="../assets/propaganda/articlepro1.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/project_logo.svg" class="banner_text_img">
                    <h1>Online cloud system for booth builder</h1>
                    <!-- <p style="line-height: normal;margin-top: 18px;margin-bottom: 18px;font-weight: 400;">Exhibition decoration project management full process integrated real-time<br/> online cloud management system</p>
                    <ul class="banner_ul">
                        <li data-type="Project展装云" data-href="/web/user/login" id="ljsy"><a href="javascript:;">Try it now</a></li>
                    </ul> -->
                </div>
            </div>
            <div class="article" style="width: 1600px;margin-top:70px;margin-bottom: 140px;">
                <!-- <h1>Project Cloud Solution</h1>
                <div class="tit_con">
                    <p>Solve the problems in the traditional model, such as chaotic enterprise marketing process, difficult supervision of sales traces, low project customer stickiness, difficult project financial control, chaotic supply system management, and poor on-site execution quality.</p>
                </div> -->
                <div class="article_con clearfix">
                    <div class="article_con_module" style="width:30%">
                        <h2>Improve business agility</h2>
                        <ul>
                            <li><i class="square"></i>Industry-specific capabilities and best practices</li>
                            <li><i class="square"></i>Based on the management process of hundreds of exhibition <br/><span style="margin-left: 18px;">decoration companies</span></li>
                            <li><i class="square"></i>Real-time embedded BI statistical analysis</li>
                            <li><i class="square"></i>Covering the entire business automation process of exhibition <br/><span style="margin-left: 18px;">decoration enterprises</span></li>
                        </ul>
                    </div>
                    <div class="article_con_module" style="width:34%">
                        <h2>Gain stability and control</h2>
                        <ul>
                            <li><i class="square"></i>Tencent Cloud deployment ensures data security</li>
                            <li><i class="square"></i>Integrated business intelligence to quickly seize new opportunities</li>
                            <li><i class="square"></i>Project creation, project distribution, simplified process</li>
                            <li><i class="square"></i>Register and use, fast deployment</li>
                        </ul>
                    </div>
                    <div class="article_con_module" style="width:36%">
                        <h2>Continuous cost reduction and sustainability</h2>
                        <ul>
                            <li><i class="square"></i>Sales tracking and customer management are synchronized and flexible</li>
                            <li><i class="square"></i>High agility in internal communication and supply management</li>
                            <li><i class="square"></i>On-site supervision and financial supervision management are efficient</li>
                            <li><i class="square"></i>Supports real-time analysis to help improve profits and efficiency</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 中间内容区域结束 -->
        <footers></footers>
        <contact></contact>
        <dialog1 data-type="Project展装云"></dialog1>
    </div>
</template>
<script>
  import headers from '@/components/Header';
  import footers from '@/components/Footer';
  import contact from '@/components/contact';
  import dialog1 from '@/components/dialog';

export default {
    components: {
      headers,
      footers,
      contact,
      dialog1
    },
    data(){
        return {
            aaaa:true,
            regex:'/^1\d{10}$/',
            langluageType:sessionStorage.getItem('langluageType')||'ch'
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/page/articlepro.vue